<template>
  <ion-page>
    <ion-content>
      <ion-tabs>
        <ion-router-outlet></ion-router-outlet>
        <ion-tab-bar slot="bottom" class="custom-tab-bar glass-tab-bar">
          <ion-tab-button tab="dashboard" href="/dashboard" class="custom-tab-button">
            <ion-icon :icon="homeOutline" class="tab-icon"></ion-icon>
            <ion-label class="tab-label hidden">{{ $t("Home") }}</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="food" href="/nutrition" class="custom-tab-button">
            <ion-icon :icon="restaurantOutline" class="tab-icon"></ion-icon>
            <ion-label class="tab-label hidden">{{ $t("Food") }}</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="habits" href="/habits" class="custom-tab-button">
            <ion-icon :icon="checkmarkCircleOutline" class="tab-icon"></ion-icon>
            <ion-label class="tab-label hidden">{{ $t("Habits") }}</ion-label>
          </ion-tab-button>

          <ion-tab-button v-if="trainingEnabled" tab="training" href="/training" class="custom-tab-button">
            <ion-icon :icon="barbellOutline" class="tab-icon"></ion-icon>
            <ion-label class="tab-label hidden">{{ $t("Training") }}</ion-label>
          </ion-tab-button>

          <ion-tab-button tab="calendar" href="/calendar" class="custom-tab-button">
            <ion-icon :icon="calendarOutline" class="tab-icon"></ion-icon>
            <ion-label class="tab-label hidden">{{ $t("Agenda") }}</ion-label>
          </ion-tab-button>

        </ion-tab-bar>
      </ion-tabs>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">

import {
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonIcon,
  IonLabel,
  IonPage,
  IonRouterOutlet,
  IonContent
} from '@ionic/vue';
import {
  barbellOutline,
  calendarOutline,
  homeOutline,
  restaurantOutline,
  checkmarkCircleOutline
} from 'ionicons/icons';
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useTenantStore } from '@/stores/tenantStore';

const tenantStore = useTenantStore();
const { trainingEnabled } = storeToRefs(tenantStore);

onMounted(() => {
  // Resolve the tenant feature flags so the training tab can hide itself.
  tenantStore.checkFeatures();
});
</script>

<style scoped>
/* 70px CONTENT, niet 70px totaal. De navigatiebalk-inset komt uit de gedeelde
   regel `.md ion-tab-bar` in variables.scss en hoort daar bovenop te komen, niet
   ervan af. Ionic zet daarvoor zelf `box-sizing: content-box !important` in de
   shadow DOM van ion-tab-bar; dat wint van de `* { box-sizing: border-box }` van
   Tailwind (nagemeten in Chrome: 70px + 24px inset = 94px). We schrijven het hier
   nog een keer op omdat die 70px anders stilzwijgend van een !important in een
   andere library afhangt - dezelfde waarde, dus visueel verandert er niets. */
.custom-tab-bar {
  --background: var(--ion-background-color, #f5f7fa);
  --border: 1px solid #e0e0e0;
  box-sizing: content-box;
  height: 70px;
}

.custom-tab-button {
  --color: #9e9e9e;
  --color-selected: var(--ion-color-primary);
  flex-direction: column;
  gap: 4px;
}

.tab-icon {
  font-size: 24px;
  margin-bottom: 2px;
}

.tab-label {
  font-size: 12px;
  font-weight: 500;
  margin-top: 2px;
}

/* Active tab styling */
.custom-tab-button.tab-selected {
  --color: var(--ion-color-primary);
}

.custom-tab-button.tab-selected .tab-icon {
  color: var(--ion-color-primary);
}

.custom-tab-button.tab-selected .tab-label {
  color: var(--ion-color-primary);
  font-weight: 600;
}
</style>

<style>
/* Dark mode for tab bar */
.dark-mode .custom-tab-bar {
  --background: #1a1a24 !important;
  --border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.dark-mode .custom-tab-button {
  --color: rgba(255, 255, 255, 0.5) !important;
  --color-selected: var(--ion-color-primary) !important;
}

.dark-mode ion-tab-bar {
  --background: #1a1a24 !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
}
</style>
